import React, {useContext} from "react";
import {Link} from "react-router-dom";
import "./Navbar.scss";
import UserContext from "../../context/UserContext";
import domain from "../../util/domain";
const axios = require('axios').default;

function Navbar() {
    const { user, getUser } = useContext(UserContext);
    async function logOut() {
        await axios.get(domain + "/auth/logOut");
        await getUser();
    }
    return (
        <div className="navbar">
        <Link to="/"><h1>Home</h1></Link>
            { user === null ?  (<>
                    <Link to="/login"><h1>Log in</h1></Link>
                      <Link to="/register"><h1>Register</h1></Link>
                </>) : (
                    <button className="btn-logout" onClick={logOut}>Log out</button>
                )}
            <Link to="/jobs"><h1>Search Jobs</h1></Link>
    </div>
    );
}

export default Navbar;